import { FC } from 'react'
import { CheckYourEmail } from '.'
import { StepCommonProps, JoinLayout } from '../OpenAccountPage'

export const CheckYourEmailStep: FC<StepCommonProps> = () => {
  return (
    <JoinLayout title="Check your email for one last step">
      <CheckYourEmail />
    </JoinLayout>
  )
}
